module.exports = __webpack_public_path__ + "static/img/titImg1.17c8242d.png";